import { FormProps, InputSelect } from "@components-common/forms";
import { FC, useEffect, useMemo, useState } from "react";
import { InputName, InputDescription } from "@components-common/forms";
import { Material } from "./types/material";
import { useNavigate } from "react-router-dom";
import { useFormikContext } from "formik";
import { application } from "../../../_runtime/bootstrap";
import { useNotifications } from "@hooks";
import { Loader } from "taltech-styleguide";
import { convertToTitleCase } from "@dirootie-extensions/javascript";
import { useUserContext } from "../../../_runtime/iam/session.context";
import { roleMapper } from "../../../_runtime/iam/session.provider";

export const materialsMapper = (materials: string[]) => {
  return materials.map((material) => {
    if (material === "PAINTORCOATING")
      return { value: material, text: "Paint/Coating" };
    return { value: material, text: convertToTitleCase(material) };
  });
};

type Props = {
  materialClasses: string[];
};

export const MaterialFormContent: FC<Props> = ({ materialClasses }) => {
  const listOfMaterials: any = useMemo(
    () => materialClasses,
    [materialClasses]
  );

  const body = (
    <div>
      <InputName elementClass="required" />
      <InputSelect
        id="class"
        options={listOfMaterials}
        elementClass="required"
      />
      <InputDescription />
    </div>
  );
  return body;
};

export const MaterialForm: FC<FormProps<Material>> = ({ ...props }) => {
  const nav = useNavigate();
  const notifications = useNotifications();
  const { userId, userRole } = useUserContext();
  const formik = useFormikContext();
  const [materialClasses, setMaterialClasses] = useState<any | undefined>(
    undefined
  );

  useEffect(() => {
    application
      .getHttpClient()
      .get("/buildingsms/materials/materialClasses")
      .then((response: any) => {
        setMaterialClasses(materialsMapper(response.body as string[]));
      })
      .catch((error: any) => {
        notifications.error({ title: error.response.data.detail });
        setMaterialClasses([]);
      });
  }, []);

  useEffect(() => {
    if (formik.isSubmitting) {
      const values: any = formik.values;
      const data = {
        name: values.name,
        description: values.description,
        class: values.class,
        sourceId: userId,
        sourceType: userRole === roleMapper.Student ? "USER" : "SYSTEM",
      };

      if (formik.isValid) {
        if (props.id === "form_create") {
          application
            .getHttpClient()
            .post("/buildingsms/materials", data)
            .then(() => {
              nav(-1);
            })
            .catch((error: any) => formik.setSubmitting(false));
        } else {
          application
            .getHttpClient()
            .put(`/buildingsms/materials/${values.id}`, data)
            .then(() => {
              nav(-1);
            })
            .catch((error: any) => formik.setSubmitting(false));
        }
      }
    }
  }, [formik.isSubmitting]);

  return materialClasses === undefined ? (
    <Loader overlay />
  ) : (
    <MaterialFormContent materialClasses={materialClasses} />
  );
};
